<div class="checkbox">
  <div class="checkbox__container">
    <p-checkbox
      [inputId]="id()"
      [binary]="true"
      [disabled]="disabled()"
      [value]="value()"
      (onChange)="updateValue($event.checked)"
      (onBlur)="markAsTouched()" />

    <label class="checkbox__label">
      <ng-content />
    </label>

    @if (isRequired()) {
      <span class="checkbox__required">*</span>
    }
  </div>

  <ui-error class="checkbox__error" [error]="error()" />
</div>
